import MabinsoModel from '../../app/models/MabinsoModel';
import Globals from '../../../utils/Globals';

class Model extends MabinsoModel {
    urlRoot = Globals.baseUrl + 'interfaces/log';
}
export default Model;
